import { IoSend } from "react-icons/io5";

export const SendMSG_BTN = ({ className, onClick }: { className?: string; onClick?(): void }) => {
  return (
    <button className={` size-8 circle-bg-hover z-50  ${className} `} onClick={onClick}>
      <IoSend className={`text-gray-600  text-xl  `} />
    </button>
  );
};
